import React, { useEffect, useState, useRef } from "react";
import {
  Space,
  Tabs,
  Watermark,
  Button,
  Table,
  Modal,
  Form,
  Input,
  Spin,
  message,
  Tooltip,
  InputNumber,
} from "antd";
import axios from "axios";
import API from "@/api";
import "./index.less";

function Mxlp() {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState(1);
  const [size, setSize] = useState(10);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [type, setType] = useState("add");
  const [selectedRow, setSelectedRow] = useState({});
  const [refresh, setRefresh] = useState("");
  const [spinning, setSpinning] = useState(true);

  const formRef = useRef();

  useEffect(() => {
    setLoading(true);
    axios
      .get(API.getTokenList, {
        params: {
          page: current - 1,
          size,
        },
      })
      .then((res) => {
        setData(res?.data?.result?.data || []);
        setTotal(res?.data?.result?.total || 0);
        setLoading(false);
        setSpinning(false);
      });
  }, [current, size, refresh]);

  // 复制到剪贴板函数
  const copyToClipboard = async (text) => {
    try {
      // 使用现代浏览器的Clipboard API
      await navigator.clipboard.writeText(text);

      // 更新状态以显示成功反馈
      // setIsCopied(true);
      // setShowTooltip(true);

      // 2秒后重置状态
      setTimeout(() => {
        // setIsCopied(false);
      }, 2000);

      // 3秒后隐藏提示
      setTimeout(() => {
        // setShowTooltip(false);
      }, 3000);
      message.success("复制成功");
    } catch (err) {
      console.error("复制失败:", err);
      // 降级方案：使用传统方法
      fallbackCopyTextToClipboard(text);
    }
  };

  // 降级方案：传统复制方法
  const fallbackCopyTextToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;

    // 避免屏幕滚动
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand("copy");
      if (successful) {
        // setIsCopied(true);
        // setShowTooltip(true);

        setTimeout(() => {
          // setIsCopied(false);
        }, 2000);

        setTimeout(() => {
          // setShowTooltip(false);
        }, 3000);
      }
    } catch (err) {
      console.error("降级复制方案也失败了:", err);
      // alert('复制失败，请手动选择文本进行复制');
    }
    message.success("复制成功");
    document.body.removeChild(textArea);
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
      }}
    >
      <Space
        style={{
          padding: "10px 0",
        }}
      >
        <Button
          type="primary"
          onClick={() => {
            setType("add");
            setOpen(true);
          }}
        >
          新增
        </Button>
      </Space>
      <Spin spinning={spinning}>
        <Table
          bordered
          rowKey={"tokenId"}
          dataSource={data}
          columns={[
            {
              title: "序号",
              dataIndex: " ",
              width: 80,
              align: "center",
              render(val, row, index) {
                return index + 1;
              },
            },
            {
              title: "名称",
              dataIndex: "name",
            },
            {
              title: "已使用额度（万tokens）",
              dataIndex: "usedQuota",
            },
            {
              title: "令牌额度（万tokens）",
              dataIndex: "remainQuota",
            },
            {
              title: "Key",
              dataIndex: "key",
              render(val) {
                return (
                  <div
                    style={{
                      display: "flex",
                    }}
                  >
                    <span
                      style={{
                        display: "inline-block",
                        width: "60px",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <Tooltip placement="topLeft" title={val}>
                        {val}
                      </Tooltip>
                    </span>
                    <span
                      style={{
                        color: "#0000ffa5",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        copyToClipboard(val);
                      }}
                    >
                      复制
                    </span>
                  </div>
                );
              },
            },
            {
              title: "创建时间",
              dataIndex: "createdTimeStr",
            },
            {
              title: "已授权模型",
              dataIndex: "models",
              render(val, row) {
                return val && val.length ? val.join(",") : "";
              },
            },
            {
              title: "操作",
              dataIndex: "id",
              align: "center",
              render(val, row) {
                return (
                  <>
                    <Button
                      type="link"
                      onClick={() => {
                        setType("edit");
                        setSelectedRow(row);
                        setOpen(true);
                      }}
                    >
                      修改
                    </Button>
                    <Button
                      type="link"
                      onClick={() => {
                        Modal.confirm({
                          title: "删除",
                          content: "确定删除这条数据吗？",
                          okText: "确定",
                          cancelText: "取消",
                          onOk() {
                            axios
                              .post(API.deleteToken, { tokenId: val })
                              .then((res) => {
                                if (res?.data?.resultCode === 0) {
                                  setRefresh(Math.random());
                                } else {
                                  message.error(res?.data?.errorMsg);
                                }
                              })
                              .catch(() => {});
                          },
                        });
                      }}
                    >
                      删除
                    </Button>
                  </>
                );
              },
            },
          ]}
          loading={loading}
          pagination={{
            position: ["bottomRight"],
            current: current,
            pageSize: size,
            onChange: (cur, pageSize) => {
              setCurrent(cur);
              setSize(pageSize);
            },
            total: total,
            showQuickJumper: true,
          }}
        />
      </Spin>

      <Modal
        title={type === "add" ? "新增令牌" : "修改令牌"}
        open={open}
        destroyOnHidden
        onCancel={() => {
          setOpen(false);
          setType("");
          setSelectedRow({});
        }}
        okText="确定"
        cancelText="取消"
        onOk={() => {
          formRef.current
            .validateFields()
            .then((valus) => {
              console.log(valus);
              if (type === "add") {
                axios.post(API.createToken, { ...valus }).then((res) => {
                  if (res?.data?.resultCode === 0) {
                    setRefresh(Math.random());
                    setOpen(false);
                  } else {
                    message.error(res?.data?.errorMsg);
                  }
                });
              } else {
                axios
                  .post(API.updateToken, { ...valus, tokenId: selectedRow?.id })
                  .then((res) => {
                    if (res?.data?.resultCode === 0) {
                      setRefresh(Math.random());
                      setOpen(false);
                    } else {
                      message.error(res?.data?.errorMsg);
                    }
                  });
              }
            })
            .catch(() => {});
        }}
      >
        <Form
          name="lp"
          ref={formRef}
          initialValues={
            type === "add"
              ? {}
              : {
                  name: selectedRow?.name,
                  remainQuota: selectedRow?.remainQuota,
                }
          }
        >
          <Form.Item
            label="名称"
            name="name"
            rules={[
              {
                required: true,
                message: "请输入名称",
              },
            ]}
            labelCol={{
              span: 4,
            }}
          >
            <Input />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
                message: "请填写令牌配额",
              },
            ]}
            label="令牌配额"
            labelCol={{
              span: 4,
            }}
            name="remainQuota"
          >
            <InputNumber min={0} suffix={"万tokens"} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default Mxlp;
